import {FaCheck} from "react-icons/fa";
import {activityTypeMember} from "@/json/activityTypes";

export default function ActivityMemberTypeTag({is_admin, type}){
    const activityType = activityTypeMember.find(el => el.id === type);
    if(is_admin){
        return(
            <div className={`py-1 px-3 rounded font-semibold text-sm text-white bg-primary flex items-center gap-x-2`}>
                <FaCheck/>
                Cwf
            </div>
        )
    }else{
        return(
            <div className={`py-1 px-3 rounded font-semibold text-sm text-white bg-primary `}>
                {activityType.value}
            </div>
        )
    }
}